import { routePath } from "../assets/routes";
import { screenshots } from "../assets/screenshots";
import { useLocation } from "react-router-dom";
import { PageMeta } from "../components/PageMeta";
import { landingByLocale, privacyByLocale } from "../content";
import type { Locale } from "../content/types";
import { Footer } from "../sections/Footer";
import { Header } from "../sections/Header";

type PrivacyPageProps = {
  locale: Locale;
};

export function PrivacyPage({ locale }: PrivacyPageProps) {
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const contentOnly = query.get("embed") === "1";
  const privacy = privacyByLocale[locale];
  const landing = landingByLocale[locale];

  return (
    <div className="page-shell">
      <PageMeta title={privacy.seo.title} description={privacy.seo.description} locale={locale} kind="privacy" />
      {contentOnly ? null : <Header content={landing} locale={locale} page="privacy" />}
      <main className="privacy-page">
        <article className="privacy-article">
          <div className="brand-link content-only-brand" aria-label="Prismark">
            <img src={screenshots.icon} alt="Prismark" width="28" height="28" />
            <span>Prismark</span>
          </div>
          <h1>{privacy.title}</h1>
          <p className="privacy-updated">{privacy.updated}</p>
          <p className="privacy-intro">{privacy.intro}</p>
          {privacy.sections.map((section) => (
            <section key={section.title}>
              <h2>{section.title}</h2>
              {section.body.map((paragraph) => (
                <p key={paragraph}>{paragraph}</p>
              ))}
            </section>
          ))}
          {privacy.termsLink && !contentOnly ? (
            <aside className="privacy-link-card">
              <p>{privacy.termsLink.body}</p>
              <a href={routePath(privacy.termsLink.href)}>{privacy.termsLink.label}</a>
            </aside>
          ) : null}
        </article>
      </main>
      {contentOnly ? null : <Footer content={landing.footer} locale={locale} page="privacy" />}
    </div>
  );
}
